<template>
  <div id="app">
    <div class="header">
      <van-nav-bar title="" left-text="返回" @click-left="backJump" left-arrow>
        <template #right>
          <van-icon name="ellipsis" />
        </template>
      </van-nav-bar>
    </div>
    <div class="body">
      <div class="content">
        <div class="content_top" style="height: 80px;margin-top:20px" v-for="item in costContent">
          <div style="float: left">{{item.costName}}</div>
          <div class="clear" style="clear: both"></div>
          <span style="font-size:12px">{{item.createTime}} - {{item.endTime}}</span>
          <div style="float: right;line-height: 5px">{{item.money}}元</div>
          <div>
            <van-button type="info" v-if="item.status == 0" @click="goMoney(item)" block>立即缴费</van-button>
            <van-button type="info" v-else disabled block>已完成缴费</van-button>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import {costList, billOrderNo} from "../common/api/cost";
import wx from "weixin-js-sdk";

export default {
  name: "cost",
  data(){
    return{
      costContent:[],
      show: false,
      actions: [
        {
          name: '选项',
        },
        {
          name: '选项',
        },
        {
          name: '选项',
          subname: '描述信息',
          openType: 'share',
        },
      ],
    }
  },
  mounted() {
    this.getList()
  },
  methods:{
    changeCost(e){
      costList({costType:e.id}).then(response => {
        this.costContent = response.data.items
      })
      this.show = false
    },
    getList(con){
      costList().then( response => {
        this.costContent = response.data.items
      })
    },
    goMoney(item){
      let cont = {
        "price":0.01,
        "costRecordId":item.id,
        "remark":item.costName
      }
      console.log(cont)
      // return
      billOrderNo(JSON.stringify(cont)).then((response)=>{
        console.log(response)
        this.jsap(response.data.orderNo,5)
      }).catch(function (error) {
        console.log(error);
      })
    },
    jsap(orderNo,devType){
      console.log(orderNo)
      this.typ = window.__wxjs_environment
      var isWxMini = window.__wxjs_environment === 'miniprogram'     // 判断场景是否小程序
      const url = '/pages/logs/logs?orderNo='+orderNo +'&token=' + this.$cookies.get("token") + '&devType=' + devType
      console.log(url)
      if (isWxMini) {
        this.typ = "11跳转"
        wx.miniProgram.navigateTo({
          url: url
        });
      } else {
        this.$toast('请在微信端重新操作')
      }
    },
    backJump(){
      this.$router.replace("/index");
    },
  }
}
</script>

<style scoped>
.body{
  background-color: #f6f6f6;
  height: 100vh;
  padding: 20px;
}
.content{

}
.content_top{
  padding: 10px;
  background-color: #fff;
  border-radius: 20px;
}
.van-button--normal{
  margin-top:10px
}
.van-button{
  height: 30px;
}
</style>